import React, { Component } from 'react';
import { API_ROOT } from '../../../baseUrls';
import { withStyles } from "@mui/styles";
import { connect } from 'react-redux';
import { updateEmail } from '../../../state/actions/updateDataActions';
import {
  Box,
  TextField,
  Typography,
  Button,
} from '@mui/material';
import Alert from '@mui/material/Alert';

const styles = () => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  }
})

class Email extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailMode: 'display',
      newEmail: '',
      confirmNewEmail: '',
      showEmailSuccessMessage: false,
      showEmailValidationErrors: false,
      emailValidationMessage: '',
    }
  }

  updateEmail() {
    if (this.state.newEmail !== this.state.confirmNewEmail) {
      return this.setState({ showEmailValidationErrors : true, emailValidationMessage: ["Email addresses don't match."] })
    }

    const formData = new FormData()
    formData.append("user[email]", this.state.newEmail)
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${ API_ROOT }/users/${ this.props.user.uid }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.props.updateEmail(this.state.newEmail)
        this.setState({
          emailMode: 'display',
          showEmailSuccessMessage: true,
          showEmailValidationErrors : false,
          newEmail: '',
          confirmNewEmail: ''})
      }
      else if (data.status === 'error') {
        this.setState({
          showEmailSuccessMessage: false,
          showEmailValidationErrors : true,
          emailValidationMessage: data.message
        })
      }
    })
    .catch(error => console.error(error))
  }

  renderEmailDisplay() {
    return (
      <Box>
        { this.state.showEmailSuccessMessage ? 
          <Box style={{marginBottom: "1rem"}}>
            <Alert onClose={ () => this.setState({ showEmailSuccessMessage: false }) }>
              Email was updated.
            </Alert>
          </Box> 
          : '' 
        }
        <Box sx={{ display: { xs: 'block', md: 'none' } }} pb={2}><Typography style={{marginRight:"0.5rem", whiteSpace: "nowrap"}}>Email</Typography></Box>
        <div style={{display:"flex", gap:"0.5rem"}}>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}><Typography style={{whiteSpace: "nowrap"}}>Email</Typography></Box>
          <Box display="flex" flexGrow={1} justifyContent="center"><Typography style={{wordBreak:"break-word"}}>{ this.props.user.email }</Typography></Box>
          <Button variant="contained" color="primary" onClick={ () => this.setState({ emailMode: 'form' }) }>Update</Button>
        </div>
      </Box>
    )
  }

  renderEmailForm(classes) {
    return(
      <Box>
        <Typography className={classes.cardTitle} variant="subtitle1" gutterBottom>
          Update email
        </Typography>
        { this.state.showEmailValidationErrors ?
          <Alert onClose={ () => this.setState({ showEmailValidationErrors: false }) } severity="error">
            { this.state.emailValidationMessage.map(m => <div>{m}</div>) }
          </Alert>
          : ''
        }
        <Box className={ classes.fieldWrapper }>
          <TextField
            label="Current email"
            value={ this.props.user.email }
            margin="dense"
            size="small"
            fullWidth
            disabled
          />
        </Box>
        <Box className={ classes.fieldWrapper }>
          <TextField
            label="New email"
            value={ this.state.newEmail }
            margin="dense"
            size="small"
            fullWidth
            onChange={ evt => this.setState({ newEmail: evt.target.value }) }
          />
        </Box>
        <Box className={ classes.fieldWrapper }>
          <TextField
            label="Confirm new email"
            value={ this.state.confirmNewEmail }
            margin="dense"
            size="small"
            fullWidth
            onChange={ evt => this.setState({ confirmNewEmail: evt.target.value }) }
            onKeyDown={ evt => { if (evt.key === 'Enter') this.updateEmail.call(this) } }
          />
        </Box>
        <Box className={ classes.buttonWrapper }>
          <Button variant="contained" color="primary" onClick={ this.updateEmail.bind(this) }>Update</Button>
          <Button style={{ marginLeft: 8 }} variant="contained" color="primary" onClick={ () => this.setState({ emailMode: 'display' }) }>Cancel</Button>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props
    return (this.state.emailMode === 'display') ? this.renderEmailDisplay(classes) : this.renderEmailForm(classes)
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
  }
}

const mapDispatchToProps = {
  updateEmail,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Email))
